<template lang="html">
  <div class="image-inputs">
    <post-image-input v-for="input in inputs"
                 :prohibition="prohibition"
                 :disabled-video="disabledVideo"
                 :input="input"
                 :key="input.id"
                 :entity="entity"
                 @imageChangedHyperlink="changeInputHyperlink"
                 @imageUploaded="addInput"
                 @imageChanged="changeInput"
                 @inputDeleted="deleteInput"
    ></post-image-input>
  </div>
</template>

<script>
// Component to uploading images

export default {
  props: ['images', 'minId', 'idCoefficient', 'prohibition', 'videos', 'disabledVideo', 'interviewImages', 'validation', 'entity'],
  data() {
    return {
      inputs: [],
      lastId: 1,
      index: 1,
      contentCount: 0
    };
  },
  methods: {
    addInput(input) {
      this.inputs.forEach((contentInput) => {
        if(contentInput.type) return ;

        if (input.type === 'image') {
          if (contentInput.imageId === input.oldImageId) {
            contentInput.imageId = input.imageId;
            contentInput.type = input.type;
          }
        }

        if (input.type === 'video') {
          if (contentInput.videoId === input.oldVideoId) {
            contentInput.videoId = input.videoId;
            contentInput.type = input.type;
          }
        }
      });

      this.contentCount += 1;

      if (this.contentCount < 5) {
        this.lastId += this.index;
        this.inputs.push({
          id: this.lastId,
        });
      }

      this.$emit('contentUploaded', {
        content: this.inputs
      });
    },
    changeInput(input) {
      let itemIndex = window._.findIndex(this.inputs, function (item) {
        if (input.type === 'image' && !input.videoId) {
          return item.imageId == input.oldImageId;
        }

        if (input.type === 'video' && !input.imageId) {
          return item.videoId == input.oldVideoId;
        }

        if (input.type === 'image' && input.videoId) {
          return item.videoId == input.videoId;
        }

        if (input.type === 'video' && input.imageId) {
          return item.imageId == input.imageId;
        }
      });

      if (input.type === 'image') {
        this.inputs[itemIndex].imageId = input.imageId;
        this.inputs[itemIndex].videoId = null;
      }

      if (input.type === 'video') {
        this.inputs[itemIndex].videoId = input.videoId;
        this.inputs[itemIndex].imageId = null;
      }

      this.inputs[itemIndex].type = input.type;

      this.$emit('contentUploaded', {
        content: this.inputs
      });
    },
    deleteInput(deletedInput) {
      this.inputs = this.inputs.filter(function (input) {
        let check = input.type !== deletedInput.type;

        if (deletedInput.type === 'image') {
          check = check || deletedInput.imageId != input.imageId;
        }

        if (deletedInput.type === 'video') {
          check = check || deletedInput.videoId != input.videoId;
        }

        return check;
      });

      this.$emit('contentUploaded', {
        content: this.inputs
      });

      this.contentCount -= 1;

      let emptyInput = this.inputs.filter((input) => {
        return !(input.imageId || input.videoId);
      });

      if (this.contentCount < 5 && !emptyInput.length) {
        this.lastId += this.index;
        this.inputs.push({
          id: this.lastId,
        });
      }
    },

    changeInputHyperlink(input) {
      let itemIndex = window._.findIndex(this.inputs, function (item) {
        return item.imageId == input.imageId;
      });

      this.inputs[itemIndex].hyperlink = input.hyperlink;

      this.$emit('contentUploaded', {
        content: this.inputs
      });
    },
  },

  mounted() {
    if (this.idCoefficient) {
      this.index = this.idCoefficient;
    }

    let inputs = [];

    this.lastId = this.minId ? this.minId : 1;

    if ((this.images === undefined || !Object.keys(this.images).length) && (!this.videos || (this.videos && !this.videos.length))) {
      inputs.push({
        id: this.lastId
      });

      this.inputs = inputs;

      return ;
    }

    let maxId = this.lastId;

    if (this.images !== undefined && Object.keys(this.images).length) {
      let imageIds = Object.keys(this.images);

      imageIds.forEach((imageId) => {
        inputs.push({
          type: 'image',
          id: this.images[imageId].id,
          image: this.images[imageId].imagePath,
          imageId: this.images[imageId].id,
          hyperlink: this.images[imageId].hyperlink,
        });

        this.contentCount += 1;

        if (+imageId > maxId) maxId = +imageId;
      });
    }

    if (this.videos) {
      this.videos.forEach((video) => {
        inputs.push({
          type: 'video',
          id: video.id,
          image: '',
          videoName: video.video_name,
          videoId: video.id
        });

        this.contentCount += 1;

        if (+video.id > maxId) maxId = +video.id;
      });
    }

    this.$emit('contentUploaded', {
      content: inputs
    });

    if (inputs.length < 5 && !this.prohibition) {
      inputs.push({
        id: maxId + this.index
      });

      this.contentCount += 1;
    }

    this.lastId = maxId + this.index;

    this.inputs = inputs;
  }
};
</script>
